var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner-with-logo"},[_c('transition',{attrs:{"name":"fade"}},[(_vm.showDefault)?_c('h2',[_vm._t("default")],2):_vm._e()]),_c('transition',{attrs:{"name":"fade"}},[(!_vm.showDefault)?_c('h2',[_vm._t("second")],2):_vm._e()]),_c('img',{attrs:{"src":require("@/assets/svg/icons/banner-logo.svg"),"alt":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }